<template>
    <div class="mobile-menu">
        <div v-scroll-stop class="x-container" :class="{ 'hidden-left' : !selectedCategory }" @click="selectedCategory = null">
            <div class="x" :style="{ backgroundImage : `url('${require('../assets/icons/close.png')}')` }"></div>
        </div>
        <div class="flavor-modal-overlay mobile" :class="{ 'hidden-left' : !selectedCategory }" @click="selectedCategory = null">
            <div v-scroll-stop class="flavor-modal mobile" @click.stop>
                <div class="container">
                    <FlavorCard v-for="(flavor, index) in filteredFlavors" :key="flavor.vqid" :flavor="flavor" :column="index % 3"></FlavorCard>
                </div>
            </div>
        </div>
        <div class="categories">
            <div v-for="(n, i) in 4" :key="i" class="touple mobile" >
                <div 
                    @click="selectedCategory = flavorCategories[i * 2]"
                    class="card" 
                    :style="{ backgroundImage : `url('${require('../assets/categories/' + flavorCategories[(i * 2)] + '.jpg')}')` }"
                >
                    <h3>{{ flavorCategories[(i * 2)] }}</h3>
                </div>
                <div 
                    @click="selectedCategory = flavorCategories[(i * 2) + 1]"
                    class="card" 
                    :style="{ backgroundImage : `url('${require('../assets/categories/' + flavorCategories[(i * 2) + 1] + '.jpg')}')` }"
                >
                    <h3>{{ flavorCategories[(i * 2) + 1] }}</h3>
                </div>
            </div>
        </div>
        <div style="height: 30px; background: #97d3ce"></div>
    </div>
</template>

<script>
import axios from 'axios'
import FlavorCard from '@/components/FlavorCard.vue'

export default {
    components: { FlavorCard },
    data() {
        return {
            flavors: [],
			flavorCategories: [],
			selectedCategory: null,
            pageBottom: null,
            showBottomNav: false,
            showOverlay: false
        }
    },
    created: async function() {
        this.flavors = (await axios.get('https://api.thevapequeen.com/flavors').catch(e => console.log(e))).data
		for (let flavor of this.flavors) {
			if (this.flavorCategories.indexOf(flavor.category) === -1) this.flavorCategories.push(flavor.category)
		}
    },
	computed: {
		filteredFlavors() {
            let flavors = this.flavors
            if (!this.selectedCategory) return flavors.sort((a, b) => a.name[0] < b.name[0] ? -1 : 1)
			else return flavors.filter(x => x.category === this.selectedCategory).sort((a, b) => a.name - b.name)
		}
	},
}
</script>

<style lang="scss">
    .mobile, .x-container {
        transition: 0.5s;
    }
    .hidden-left {
        left: -100% !important;
        transition: 0.5s all;
    }
    .x-container {
        position: fixed;
        z-index: 10;
        top: 0;
        left: calc(100% - (70px));
        width: 70px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        .x {
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            height: 80px;
            width: 70%;
        }
    }
    .flavor-modal-overlay.mobile {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Nunito Sans;
        background: rgba(0, 0, 0, 0.4);
        .flavor-modal.mobile {
            width: 500px;
            background: transparent;
            border-radius: 0;
            overflow: scroll;
            z-index: 4;
            .flavor-card {
                width: 100%;
                margin-left: 0;
                margin-right: 0;
            }
        }
    }
    .mobile-menu {
        background: #97d3ce;
    }
    .touple.mobile {
        flex-direction: row;
        height: 300px;
        padding: 10px;
        .card { 
            margin-left: 10px !important;
            margin-right: 10px !important;
        }
    }
</style>
